import ModalRoot from "../index";
import styles from "./DownloadScreensModal.module.scss";
import React, { useState } from "react";
import DownloadScreenForm from "./DownloadScreenForm";
import { usePaywallsFormSubmit } from "../../../../hooks/usePaywallsFormSubmit";
import DownloadScreenGratitude from "./DownloadScreenGratitude";

const DownloadScreensModal = ({ show, setShow, data }) => {
  const [showGratitude, setShowGratitude] = useState(false);
  const handleSubmit = usePaywallsFormSubmit(() => setShowGratitude(true));

  return (
    <ModalRoot showModal={show} setShowModal={setShow}>
      <div className={styles.container}>
        {!showGratitude ? (
          <DownloadScreenForm submitHandler={handleSubmit} />
        ) : (
          <DownloadScreenGratitude />
        )}
      </div>
    </ModalRoot>
  );
};

export default DownloadScreensModal;
